import React, { useState } from 'react';
import { ChevronsLeftRightIcon } from 'lucide-react';
type BeforeAfterSliderProps = {
  before: string;
  after: string;
  alt: string;
  beforeLabel: string;
  afterLabel: string;
  dragLabel: string;
  className?: string;
};
export function BeforeAfterSlider({
  before,
  after,
  alt,
  beforeLabel,
  afterLabel,
  dragLabel,
  className = 'aspect-[4/3]'
}: BeforeAfterSliderProps) {
  const [pos, setPos] = useState(50);
  return <div className={`relative select-none overflow-hidden bg-mist ${className}`} data-id="element-97" data-mp="4buquwilqw7v">
      <img src={after} alt={`${alt} — ${afterLabel}`} loading="lazy" draggable={false} className="absolute inset-0 h-full w-full object-cover" data-id="element-98" data-mp="8ak32lrwm7px" />
      <img src={before} alt={`${alt} — ${beforeLabel}`} loading="lazy" draggable={false} className="absolute inset-0 h-full w-full object-cover" style={{
      clipPath: `inset(0 ${100 - pos}% 0 0)`
    }} data-id="element-99" data-mp="3vmuszmav6nqw" />

      <span className="pointer-events-none absolute left-3 top-3 rounded bg-navy-deep/80 px-2.5 py-1 text-xs font-semibold text-white" data-id="element-100" data-mp="2d4xp9pxzf4cr">
        {beforeLabel}
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded bg-gold px-2.5 py-1 text-xs font-semibold text-navy-deep" data-id="element-101" data-mp="291j1gd3sxjor">
        {afterLabel}
      </span>

      <input type="range" min={0} max={100} value={pos} onChange={e => setPos(Number(e.target.value))} aria-label={dragLabel} className="peer absolute inset-0 z-10 h-full w-full cursor-ew-resize appearance-none opacity-0" data-id="element-102" data-mp="2i3ij97mn4rsr" />

      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 w-0.5 -translate-x-1/2 bg-white peer-focus-visible:[&>span]:ring-4" style={{
      left: `${pos}%`
    }} data-id="element-103" data-mp="35sti2jkfkc49">
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-md ring-gold" data-id="element-104" data-mp="1bgn0n30y0z3i">
          <ChevronsLeftRightIcon className="h-5 w-5" data-id="element-105" data-mp="36k1slqxqjh3e" />
        </span>
      </div>
    </div>;
}